import React from 'react';
import { LiquiGlass } from '@liqui-design/glass';
import { Box, useMediaQuery, useTheme } from '@mui/material';

export const authGlassSx = {
  background: 'transparent',
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',
  boxShadow: '0 0 20px rgba(0, 0, 0, 0.20)',
  zIndex: 0,
} as const;

const AuthGlass: React.FC<{ tint?: string; radius?: number; frost?: number }> = ({
  // Figma 304:766: #B1B1B1 at 19%. Engine frost=0.2 applies 40%
  // opacity, so tint alpha 0.475 gives the required 0.19 composite alpha.
  tint = 'rgba(177, 177, 177, 0.475)', radius, frost = 0.2,
}) => {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  return <>
    <LiquiGlass
      aria-hidden="true" data-testid="auth-glass"
      material="auto" profile="squircle" radius={radius ?? (desktop ? 25 : 16)}
      blur={1.1} frost={frost} saturation={1} refraction={13}
      bezel={10} dispersion={0} specular={0}
      style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        borderRadius: 'inherit', pointerEvents: 'none', zIndex: -1,
        '--lq-tint': tint, '--lq-tint-deep': tint,
        '--lq-rim-hi': 'rgba(255,255,255,0)', '--lq-rim-lo': 'rgba(255,255,255,0)',
      } as React.CSSProperties}
    />
    {/* 304:766 has no stroke. Its flipped glass has a fine edge light,
        not the shared cards' opaque rim and broad bottom-right lift. */}
    <Box aria-hidden="true" data-testid="auth-glass-edge" sx={{
      position: 'absolute', inset: 0, borderRadius: 'inherit',
      pointerEvents: 'none', zIndex: -1,
      boxShadow: 'inset 0.5px -0.5px 0 0 rgba(255,255,255,0.40), inset -0.5px 0.5px 0 0 rgba(255,255,255,0.12)',
    }} />
  </>;
};

export default AuthGlass;
